import axiosInstance from './axiosInstance';

export const getAllCommissionProgress = (archived = false) =>
    axiosInstance.get(`/CommissionProgress/GetAllCommissionProgress?archived=${archived}`);

export const getCommissionProgressByAgentId = (agentId, archived = false) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressByAgentId?agentId=${agentId}&archived=${archived}`);

export const getCommissionProgressByGroupName = (groupName, archived = false) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressByGroupName?groupName=${encodeURIComponent(groupName)}&archived=${archived}`);

export const getCommissionProgressBySalesIdAgentId = (salesId, agentId) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressBySalesIdAgentId?salesId=${salesId}&agentId=${agentId}`);

export const getCommissionProgressByCommPayType = (commPayType) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressByCommPayType?commPayType=${commPayType}`);

export const updateCommissionProgress = (data) =>
    axiosInstance.put("/CommissionProgress/UpdateCommissionProgress", data);

export const getCommissionProgressById = (commProgressId) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressById?commProgressId=${commProgressId}`);